import { Component, OnInit, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';

import { AppDataService } from '../../core/services/app-data.service';
import { ReportService } from '../../core/services/report.service';
import { ExportService } from '../../core/services/export.service';
import { EquipmentService } from '../../core/services/equipment.service';
import { formatDate } from '../../core/utils/format.util';
import { environment } from '../../environments/environment';
import { ReportDateRangeComponent } from '../report-date-range/report-date-range.component';
import { ReportDateRangeService } from '../../report-date-range.service';

@Component({
  selector: 'app-overdue-returns-report',
  standalone: true,
  imports: [RouterLink, ReportDateRangeComponent],
  templateUrl: './overdue-returns-report.component.html',
  styleUrl: '../../report-shared.css',
})
export class OverdueReturnsReportComponent implements OnInit {
  private readonly appData = inject(AppDataService);
  private readonly reports = inject(ReportService);
  private readonly equipment = inject(EquipmentService);
  private readonly exporter = inject(ExportService);
  protected readonly dateRange = inject(ReportDateRangeService);
  protected readonly formatDate = formatDate;

  private readonly range = computed(() => ({
    startDate: this.dateRange.appliedStartDate(),
    endDate: this.dateRange.appliedEndDate(),
  }));

  protected readonly overdue = computed(() =>
    this.reports.getOverdueReturnsReport(this.range()),
  );

  ngOnInit(): void {
    if (!environment.useMockData) {
      this.appData.refreshAll();
      this.equipment.refreshOverdueFromApi().subscribe({ error: () => undefined });
    }
  }

  protected overdueDays(dueDate: string): number {
    const today = new Date();
    const due = new Date(dueDate);
    const msPerDay = 24 * 60 * 60 * 1000;
    return Math.max(
      0,
      Math.floor((today.getTime() - due.getTime()) / msPerDay),
    );
  }

  protected severityClass(days: number): string {
    if (days >= 7) {
      return 'critical';
    }
    if (days >= 3) {
      return 'high';
    }
    return 'medium';
  }

  exportData(): void {
    this.exporter.downloadCsv(
      `overdue-returns-report-${new Date().toISOString().slice(0, 10)}`,
      this.overdue().map((row) => ({ ...row })),
    );
  }
}
